<app-dropdown size="lg">
    <ng-container dropdown-button>
        <i class="far fa-bell"></i>
        <span class="badge badge-warning navbar-badge">15</span>
    </ng-container>
    <ng-container dropdown-menu>
        <span class="dropdown-item dropdown-header">15 Notificações</span>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item">
            <i class="fas fa-envelope mr-2"></i> 4 novas mensagens
            <span class="float-right text-muted text-sm">3 mins</span>
        </a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item">
            <i class="fas fa-money-bill-alt mr-2"></i> 8 vendas
            <span class="float-right text-muted text-sm">12 horas</span>
        </a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item">
            <i class="fas fa-file mr-2"></i> 3 novos relatórios
            <span class="float-right text-muted text-sm">2 dias</span>
        </a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item dropdown-footer"
            >Ver todas as notificações</a
        >
    </ng-container>
</app-dropdown>

<ng-template #notification>
    <a href="#" class="dropdown-item">
        <i class="fas fa-envelope mr-2"></i> 4 novas mensagens
        <span class="float-right text-muted text-sm">3 mins</span>
    </a>
    <div class="dropdown-divider"></div>
</ng-template>
